import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "group relative" }
const _hoisted_2 = { class: "hidden group-hover:block overflow-auto absolute top-0 -right-0 -left-40 z-50 p-5 pl-12 max-w-[90vw] list-decimal text-zinc-100 bg-zinc-800 rounded shadow-lg w-100" }

import { computed } from 'vue';
import { AnnotationIcon } from '@heroicons/vue/outline';


export default /*#__PURE__*/_defineComponent({
  props: {
    text: null
  },
  setup(__props: any) {

const props = __props as {
  text: string
}



const list = computed(() => {
  return props.text.split("\n").map(item => item.trim()).join('\n').split("\n\n");
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(AnnotationIcon), { class: "p-3 w-12 h-12 cursor-pointer stroke-teal-600" }),
    _createElementVNode("ol", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item, index) => {
        return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(item), 1))
      }), 128))
    ])
  ]))
}
}

})